import { PayloadAction } from '@reduxjs/toolkit';

import { DesignState, ReflowGroup } from 'editor/src/store/design/types';

const setReflowGroupsReducer = (
  state: DesignState,
  action: PayloadAction<{ spreadIndex: number; reflowGroups: ReflowGroup[] }>,
) => {
  if (!state.designData) {
    return;
  }
  const { spreadIndex, reflowGroups } = action.payload;
  const spread = state.designData.spreads[spreadIndex];
  if (!spread) {
    return;
  }
  spread.reflowGroups = reflowGroups;
};

export default setReflowGroupsReducer;
